var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIdTotalBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "112px",
    height: "112px",
    viewBox: "0 0 112 112",
    enableBackground: "new 0 0 112 112",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 112,
    height: 112,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAABwCAQAAABs6TzAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQfnCxYIHQQzJUF1AAAB1klEQVR42u2cS5LDIAwFUWruf2VmkczErjjYBv2e6vUq8cJFRwIjgpF2 RG+IyJWLmGoDo+1XfLkDq/fHOno7sz/Banr/blJW72UnhfVaa00e0S0wN2y1I9iktl5r5VOUguhQ EB0KokNBdCiIDgXRoSA65QV/lu+QfOFxraL/XCxPJ7mSonLxWijzKWqp8v3etzNEf5BJFsPyo+is YLI46QvCMCuY7nGgLQjDvGC/eR1O8Fglmd5qivaT7wlYnWw/lRL/R6UzyKTV4yiKz3rBO4fbDiuL cumssd/rSANN7xSV4TTdYArvK3guINqSfn3wesNVFcuPol6CYQWyj2Bg/c8UVSB0/YYRXCZ4/S1q LvpmPz1T/zmiU9R8TSBW0GFVx1pwlHIu63LRKWoOBdGhIDoURMdacPRMk5vXUwqGEyvosNMmuprY vxxmUFrZC/bTZptWjOyD6HgIhv49ygiqEBhDrwiGKfql6HXFrvlzePbBa81WjrXvTKa3uWUoGMGR pFEvjd2j5HBMQeJNWDrwQY8OBdGhIDoURIeC6FAQHQqiQ0F0KIgOBcGpf77oI3pHrr1gZeQpWDqG lSO4OYY69Vu4K3pVj4LfeO37XxXFw7Pua2h++PwCazM35nO7m40AAAAldEVYdGRhdGU6Y3JlYXRl ADIwMjMtMTEtMjJUMDg6Mjk6MDQrMDA6MDDeyKB9AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEx LTIyVDA4OjI5OjA0KzAwOjAwr5UYwQAAABB0RVh0bGFiZWwAbG9nb0lELnN2Z4k2XDUAAAAASUVO RK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIdTotalBlack);
export default __webpack_public_path__ + "static/media/logoIDTotalBlack.b0da528413841bc45e4d08a9ba154283.svg";
export { ForwardRef as ReactComponent };